import styled from 'styled-components';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../common/styles/constants';

export const FilterBody = styled.div`
  ${FONT_STACK};
  padding: 0;
`;

export const Title = styled.h3`
  color: ${ThemeColours.black};
  font-size: ${props => props.theme.enumFilter?.titleFontSize};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin: ${props => props.theme.enumFilter?.titleMargin};
`;

export const Caption = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 14px;
  margin: 0 0;
  margin: ${props => props.theme.enumFilter?.captionMargin};
`;
